import BulkEditCustomNamesContainer from './BulkEditCustomNamesContainer';
export default BulkEditCustomNamesContainer;
